import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ps-under-construction',
  standalone: true,
  imports: [ButtonComponent, IconComponent],
  templateUrl: './under-construction.component.html',
  styleUrl: './under-construction.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnderConstructionComponent {
  public readonly homeRequested = output<void>();
  public readonly legacyRequested = output<void>();

  protected onHome(): void {
    this.homeRequested.emit();
  }

  protected onLegacy(): void {
    this.legacyRequested.emit();
  }
}
